// extracted by mini-css-extract-plugin
module.exports = {"card":"_1W4m0","info":"_3mOdb","download":"AnP0v"};